export const DOCS_URL = 'https://docs.teramot.com';
